import qs from 'qs';
import axios from 'axios';

import { BASE_URL } from 'consts';

axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common.Accept = 'application/json';

export const http = axios.create({
  baseURL: BASE_URL,
  timeout: 15000,
  headers: {},
  xsrfCookieName: '_csrf',
  withCredentials: true,
  paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
});

export const noCredentials = axios.create({
  baseURL: BASE_URL,
  timeout: 15000,
  headers: {},
  xsrfCookieName: '_csrf',
  withCredentials: false,
  paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
});

export const createSource = () => axios.CancelToken.source();

export class SourceGroup {
  sources = [];

  add(source, label) {
    this.sources.push({ source, label });
  }

  remove(source) {
    const index = this.sources.findIndex(it => it.source === source);

    if (index > -1) {
      this.sources.splice(index, 1);
    }
  }

  cancelAll(label) {
    this.sources.forEach(it => {
      if (!label || label === it.label) {
        try {
          it.source.cancel();
        } catch (err) {}
      }
    });
  }
}

export default http;
